
import { paymentService } from '../services';
import baseMethods from './base';

const initialState = {  payments: {data: null,status:{ loading: false,ready: false }}};

export const payment = {
    namespaced: true,
    state: initialState,
    actions: {
        getAllMyPayments({ commit } )
        {
            commit('getAllMyPaymentsRequest' );
            return new Promise((resolve, reject) => {

                paymentService.getPayments().then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('getAllMyPaymentsSuccess',response.data);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('getAllMyPaymentsFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },
        deletePayment({ commit }, id)
        {
            commit('deletePaymentRequest' );
            return new Promise((resolve, reject) => {
                
                paymentService.deletePayment(id).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('deletePaymentSuccess',id);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('deletePaymentFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },       
        savePayment({ commit }, data)
        {
            return new Promise((resolve, reject) => {
                
                if(data.id <= 0)
                {
                    commit('insertPaymentRequest' );
                    paymentService.insertPayment(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('insertPaymentSuccess');
                                resolve(response.data);
                            }
                            else
                            {
                                commit('insertPaymentFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
                else
                {
                    commit('updatePaymentRequest' );
                    paymentService.updatePayment(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('updatePaymentSuccess',data);
                                resolve(response.data);
                            }
                            else
                            {
                                commit('updatePaymentFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
            })
        },
    },
    mutations: {
        getAllMyPaymentsRequest(state)
        {
            state.payments = {
                data: null,
                status:{ loading: true,ready: false }
            };
        },
        getAllMyPaymentsSuccess(state, data)
        {
            state.payments = {
                data: data,
                status:{ loading: false,ready: true }
            };
        },
        getAllMyPaymentsFailure(state)
        {
            state.payments = {
                data: null,
                status:{ loading: false,ready: false }
            };
        },
        deletePaymentRequest(state)
        {
            state.payments.status = { loading: true,ready: false };
        },
        deletePaymentSuccess(state,id)
        {
            state.payments.status = { loading: false,ready: true };
            for(var i =0; i < state.payments.data.length;i++)
            {
                if(state.payments.data[i].id == id)
                {
                    state.payments.data.splice(i,1);
                }
            }

        },
        deletePaymentFailure(state)
        {
            state.payments.status = { loading: false,ready: false };
        },
        insertPaymentRequest(state)
        {
            state.payments.status = { loading: true,ready: false };
        },
        insertPaymentSuccess(state)
        {
            state.payments.status = { loading: false,ready: true };
        },
        insertPaymentFailure(state)
        {
            state.payments.status = { loading: false,ready: false };
        },
        updatePaymentRequest(state)
        {
            state.payments.status = { loading: true,ready: false };
        },
        updatePaymentSuccess(state,data)
        {
            state.payments.status = { loading: false,ready: true };
            for(var i =0; i < state.payments.data.length;i++)
            {
                if(state.payments.data[i].id == data.id)
                {
                    var tmp = JSON.stringify(data);
                    state.payments.data[i] = JSON.parse(tmp);
                }
            }
        },
        updatePaymentFailure(state)
        {
            state.payments.status = { loading: false,ready: false };
        },        

    }
}
